import React, { useState, useEffect } from 'react';
import { MenuItem, FormControl, Select, InputLabel, CircularProgress } from '@mui/material';
import { fetchVerticals } from '@src/api/actions/verticals';

const VerticalDropdown = ({ value, onChange }) => {
  const [verticals, setVerticals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    fetchVerticals()
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          setVerticals(response.data);
        } else {
          console.error('Invalid response format');
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsError(true);
        setIsLoading(false);
        console.error('Error fetching verticals:', error);
      });
  }, []);

  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return <div>Error loading verticals. Please try again later.</div>;
  }

  return (
    <FormControl fullWidth variant="outlined" margin="normal">
      <InputLabel id="vertical-dropdown-label">Select Vertical</InputLabel>
      <Select
        labelId="vertical-dropdown-label"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        label="Select Vertical"
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {verticals.length > 0 ? (
          verticals.map((vertical) => (
            <MenuItem key={vertical.id} value={vertical.id}>
              {vertical.vertical}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="">
            <em>No verticals available</em>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default VerticalDropdown;
